<script lang="ts">
    import { link } from 'svelte-spa-router';

    export let title: string;
    export let subtitle: string = '';
    export let actionLabel: string = '';
    export let actionHref: string = '';
    export let actionIcon: string = 'plus circle';
    export let showAction: boolean = true;
</script>

<header class="app-page-header">
    <div class="header-content">
        <h1 class="page-title">{title}</h1>
        {#if subtitle}<p class="page-subtitle">{subtitle}</p>{/if}
    </div>
    {#if showAction && actionLabel && actionHref}
        <a use:link href={actionHref} class="action-btn">
            <i class="{actionIcon} icon" aria-hidden="true"></i>
            <span>{actionLabel}</span>
        </a>
    {/if}
    <slot name="actions" />
</header>

<style>
    .app-page-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: var(--space-6);
        gap: var(--space-5);
        flex-wrap: wrap;
    }

    .header-content {
        flex: 1;
        min-width: 200px;
    }

    .page-title {
        font-size: var(--text-3xl);
        font-weight: 500;
        color: var(--grey);
        margin: 0 0 var(--space-2) 0;
        text-wrap: balance;
    }

    .page-subtitle {
        font-size: var(--text-base);
        color: var(--grey-secondary);
        margin: 0;
    }

    .action-btn {
        display: inline-flex;
        align-items: center;
        gap: var(--space-2);
        padding: var(--space-3) var(--space-5);
        background: var(--primary);
        color: var(--white);
        border-radius: var(--radius-cta);
        text-decoration: none;
        font-weight: 500;
        box-shadow: var(--shadow-cta);
        transition: filter .15s, box-shadow .15s;
    }

    .action-btn:hover {
        filter: brightness(.95);
        color: var(--white);
    }

    .action-btn:focus-visible {
        outline: none;
        box-shadow: var(--focus-ring);
    }

    @media (max-width: 768px) {
        .app-page-header { flex-direction: column; align-items: stretch; }
        .action-btn { width: 100%; justify-content: center; }
        .page-title { font-size: var(--text-2xl); }
    }
</style>
